import { v4 as uuidv4 } from 'uuid'

const isString = (value: unknown): value is string => {
  return typeof value === 'string'
}

function assertCustomerUid(uid: Nullable<string>, errorMessage?: string): asserts uid is string {
  if (!isString(uid)) {
    throw new Error(errorMessage ?? 'Customer UID is not a string')
  }
}

export const getCustomerUid = (uid: Nullable<string>, errorMessage?: string): string => {
  assertCustomerUid(uid, errorMessage)

  return uid
}

export const createVendorCustomerUid = () => {
  return `${uuidv4().replace(/-/g, '').slice(0, 32)}`
}
